import { render, staticRenderFns } from "./ContactUsNew.vue?vue&type=template&id=d049690c&scoped=true&"
import script from "../../../services/applicant/contact_us/contact-us-new.js?vue&type=script&lang=js&"
export * from "../../../services/applicant/contact_us/contact-us-new.js?vue&type=script&lang=js&"
import style0 from "./ContactUsNew.vue?vue&type=style&index=0&id=d049690c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d049690c",
  null
  
)

export default component.exports